module.exports = __webpack_public_path__ + "img/404Page-illustration.6ec83e07.svg";